import React, {Component} from 'react';
import CONSTANTS from '../../config/constants';
import Config from '../../config/';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faQuestionCircle, faSearch} from '@fortawesome/pro-regular-svg-icons';
import {structure, single} from '../../../core/store/actions/block'
import {connect} from 'react-redux';
import _ from 'lodash';
import {classNamesPrefixed, getPageUrl} from "../../../core/helpers/CoreHelpers";
import axios from 'axios';
import querystring from 'querystring';
import {I18n} from 'react-i18nify';

class HelpBlock extends Component {

    constructor(props) {
        super(props);

        this.state = {
            popupVisible: false,
            keyword: "",
            searchItems: [],
            searchItemsLoading: false,
        };

        this.timer = null;
        this.activeHelpItem = null;
        this.togglePopup = this.togglePopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.onChange = this.onChange.bind(this);
        this.searchItems = this.searchItems.bind(this);
        this.clearSearchKeyword = this.clearSearchKeyword.bind(this);
        this.scrollToNode = this.scrollToNode.bind(this);
        this.setScrollToNode = this.setScrollToNode.bind(this);


    }

    togglePopup(e) {
        e.preventDefault();
        this.setState({
            popupVisible: !this.state.popupVisible
        })
    }

    clearSearchKeyword(e) {
        this.setState({
            keyword: ""
        })
    }

    searchItems() {
        const {keyword} = this.state;
        const {language} = this.props;

        let data = {
            query: keyword,
            blockType: "HelpBlockItem",
            fieldKey: "Question"
        };

        let url = Config.api.endpoint + "api/Content/search/" + language.current + "?" + querystring.stringify(data);

        let self = this;

        this.setState({
            searchItemsLoading: true
        });

        axios.get(url, Config.getApiConfig())
            .then(function (response) {
                // handle success
                self.setState({
                    searchItems: response.data,
                    searchItemsLoading: false,
                });
            })
            .catch(function (error) {
                // handle error
                self.setState({
                    searchItems: [],
                    searchItemsLoading: false,
                });
                console.log(error);
            })
    }

    onChange(e) {
        this.setState({
            keyword: e.target.value,
            searchItemsLoading: e.target.value.length > 0 ? true : false
        });
        if (this.timer) {
            clearTimeout(this.timer);
        }
        let self = this;
        this.timer = setTimeout(function () {
            self.searchItems()
        }, 500);
    }

    closePopup(e) {
        e.preventDefault();

        this.setState({
            popupVisible: false
        })
    }

    getContentFieldValue = (fieldDefinitionKey, contents = false) => {
        const {contentFields} = this.props;
        const items = contents ? contents : contentFields;
        const data = _.find(items, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    getBlockWidth = () => {
        const {width} = this.props;
        let w = 60;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (this.getContentFieldValue('Width') && this.getContentFieldValue('Width') !== CONSTANTS.BLOCK_DEFAULT_WIDTH && this.getContentFieldValue('Width') !== w) {
                w = this.getContentFieldValue('Width');
            }
        }

        return w;
    };

    componentDidMount() {
        var self = this;
        setTimeout(() => {
            self.scrollToNode();
        }, 500)
    }

    setScrollToNode(node) {
        this.activeHelpItem = node;
    }

    scrollToNode() {
        if (this.activeHelpItem) {
            this.activeHelpItem.scrollIntoView({behavior: 'smooth'});
        } else {
        }
    }

    renderInContent() {
        const {relatedContents, params: {additionalUrlParams}} = this.props;
        const items = relatedContents.map(item => {
            return {
                id: item.id,
                title: this.getContentFieldValue('Question', item.contentFields),
                answer: this.getContentFieldValue('Answer', item.contentFields),
            };
        });

        return (
            <section className={"help-block w--100"}>

                <div className="help-block--inner">
                    {items.length > 0 && items.map((item, key) => {
                        let active = additionalUrlParams && parseInt(additionalUrlParams, 10) === parseInt(item.id, 10) ? true : false;
                        //help page will show only one help item
                        if (!active) return null;
                        return (
                            <article
                                key={key}
                                className={classNamesPrefixed({
                                    'active': active
                                }, false)}>
                                <h1 ref={(node) => {
                                    if (active) {
                                        this.setScrollToNode(node);
                                    }
                                }}>{item.title}</h1>
                                <div dangerouslySetInnerHTML={{__html: item.answer}}/>
                            </article>
                        )
                    })}
                </div>

            </section>
        )
    }

    render() {
        const {relatedContents, globalFields} = this.props;
        const {keyword, searchItems, searchItemsLoading} = this.state;

        let items = relatedContents.map(item => {
            return {
                id: item.id,
                title: this.getContentFieldValue('Question', item.contentFields),
            };
        });

        if (keyword && !searchItemsLoading) {
            items = searchItems.map(item => {
                return {
                    id: item.id,
                    title: this.getContentFieldValue('Question', item.contentFields),
                };
            });
        }

        let helpPage = _.find(globalFields, {key: 'HelpPage'});
        helpPage = JSON.parse(helpPage.fieldData.data);
        let helpPageUrl = getPageUrl(helpPage.contentId);


        const data = {
            title: I18n.t('helpBlock.topSuggestions'),
            placeholder: I18n.t('helpBlock.howCanWeHelpYou'),
            btn: I18n.t('helpBlock.help'),
            suggestions: items
        };

        const suggestions = data.suggestions;
        if (this.props.content.single.contentDefinitionKey === "HelpPage") return this.renderInContent();


        return (
            <div className="popup-positioner">

                <div className={this.state.popupVisible ? 'popup-content visible' : 'popup-content'}>
                    <div className="popup-content--top">
                        <button className="close" onClick={(e) => this.closePopup(e)}>
                            <span></span>
                        </button>
                        <div className="input-wrapper">
                            <input
                                value={keyword}
                                onChange={this.onChange}
                                type="text"
                                placeholder={data.placeholder}
                            />
                            <FontAwesomeIcon icon={faSearch}/>
                        </div>
                    </div>

                    {suggestions.length > 0 &&
                    <div className="popup-content--inner">
                        <h3>{data.title}</h3>
                        <ul>
                            {suggestions.map((item, key) => (
                                <li key={key}><a href={helpPageUrl + "/" + item.id}>- {item.title}</a></li>
                            ))}
                        </ul>
                    </div>
                    }

                    {items.length === 0 &&
                    <div className={"help-block--inner"}>
                        <p>
                            {I18n.t('helpBlock.itemsNotFound')}
                        </p>
                        {keyword &&
                        <button onClick={this.clearSearchKeyword}>
                            {I18n.t('helpBlock.clear')}
                        </button>
                        }
                    </div>
                    }

                </div>

                <button className="toggleHelp" onClick={(e) => this.togglePopup(e)}>
                    {data.btn}
                    <FontAwesomeIcon icon={faQuestionCircle}/>
                </button>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        content: state.content,
        language: state.language,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        structure: (workspace) => dispatch(structure(workspace)),
        single: (id, lang) => dispatch(single(id, lang)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HelpBlock);



// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/HelpBlock.js